import React, {Component} from 'react';
// import CsodTableRow from "./CsodTableRow";
// import CsodTableHeader from "./CsodTableHeader";

//import {connect} from "react-redux";

class CsodFormFieldWraper extends Component {

    render() {
        return (
            <tr>
                <td className="cso-text-medium b">
                    {this.props.title &&
                    this.props.title
                    }
                </td>
                <td>
                    {this.props.children}
                </td>
            </tr>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         version: state.layout.version,
//     };
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         setVersion: () => dispatch(setVersion()),
//     };
// };

//Widget = connect(mapStateToProps, mapDispatchToProps)(FrontLayout)

export default CsodFormFieldWraper;


// WEBPACK FOOTER //
// ./src/widgets/components/Csod/CsodFormFieldWraper.js